module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921060834_T.72a2896a.jpg";